import { createInjectable } from '../dependency';

export const CommonEventDependency = createInjectable({
	mobileNotLoginWithReason(_reason: string) {},
});
